import { Alert, Button } from '@cmg/design-system';
import { useCallback } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import routeFactory from '../../../../../../common/util/routeFactory';
import { selectCrmIntegration } from '../../../../shared/ducks';

const mapStateToProps = state => ({
  crmIntegration: selectCrmIntegration(state),
});

type StateProps = ReturnType<typeof mapStateToProps>;

type UnlinkedUserAccountErrorProps = Readonly<StateProps>;

export function UnlinkedUserAccountError({ crmIntegration }: UnlinkedUserAccountErrorProps) {
  const navigate = useNavigate();

  const handleCreateUserAccount = useCallback(() => {
    navigate(
      routeFactory.accountUserNew.getUrlPath({ accountSubdomain: crmIntegration?.subdomain ?? '' })
    );
  }, [navigate, crmIntegration]);
  return (
    <Alert
      severity="error"
      action={
        <Button color="inherit" onClick={handleCreateUserAccount}>
          Create User Account
        </Button>
      }
    >
      This Employee Key does not match to an active user. The sales coverage will not be visible
      until a user is created with this employee key.
    </Alert>
  );
}

export default connect(mapStateToProps)(UnlinkedUserAccountError);
